import firebase from "firebase";



const firebaseConfig = {
  apiKey: "AIzaSyBXR5FgVUnZEhRfZza-MFJJbh01Mv8xyZI",
  authDomain: "slack-clone-raj.firebaseapp.com",
  projectId: "slack-clone-raj",
  storageBucket: "slack-clone-raj.appspot.com",
  messagingSenderId: "581178698709",
  appId: "1:581178698709:web:d688ee8c7382df75eceb5c"
};


const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, db };